import { render, staticRenderFns } from "./VehicleDeviationTable.vue?vue&type=template&id=5fbe77d3&scoped=true"
import script from "./VehicleDeviationTable.vue?vue&type=script&lang=js"
export * from "./VehicleDeviationTable.vue?vue&type=script&lang=js"
import style0 from "./VehicleDeviationTable.vue?vue&type=style&index=0&id=5fbe77d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbe77d3",
  null
  
)

export default component.exports